export const CREATE_BANNER_ACTION = '[Banner Action] Create Banner';
export const CONFIRMED_CREATE_BANNER_ACTION = '[Banner Action] Confirmed Create Banner';
export const GET_BANNERS = '[Banner Action] Get Banners';
export const CONFIRMED_GET_BANNERS = '[Banner Action] Confirmed Get Banners';
export const EDIT_BANNER_ACTION = '[Banner Action] Edit Banner';
export const CONFIRMED_EDIT_BANNER_ACTION = '[Banner Action] Confirmed Edit Banner';
export const CONFIRMED_DELETE_BANNER_ACTION = '[Banner Action] Confirmed Delete Banner';
export const ERROR_BANNER_ACTION = '[Banner Action] Error';
export const CLEAR_BANNER_ERROR = '[Banner Action] Clear Error';


